import { render, staticRenderFns } from "./ArticleSearchResults.vue?vue&type=template&id=37e815d8"
import script from "./ArticleSearchResults.vue?vue&type=script&lang=js"
export * from "./ArticleSearchResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports